module.exports = __webpack_public_path__ + "static/media/WoobleWobble.219a6b3c.png";